/**
 * ZoomInIcon/index.js
 * desc: zoom-in icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const ZoomInIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="zoom-in icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.zoomIn.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8.75 0C13.5825 0 17.5 3.91751 17.5 8.75C17.5 10.7105 16.8552 12.5204 15.7662 13.9793L20 18.2131L18.2131 20L13.9793 15.7662C12.5204 16.8552 10.7105 17.5 8.75 17.5C3.91751 17.5 0 13.5825 0 8.75C0 3.91751 3.91751 0 8.75 0Z"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M8.76379 15.0002C12.2081 15.0002 15.0002 12.2081 15.0002 8.76379C15.0002 5.3195 12.2081 2.52734 8.76379 2.52734C5.3195 2.52734 2.52734 5.3195 2.52734 8.76379C2.52734 12.2081 5.3195 15.0002 8.76379 15.0002ZM7.50024 5.00025H10.0002V7.50024H12.5002V10.0002H10.0002V12.5002H7.50024V10.0002H5.00025V7.50024H7.50024V5.00025Z" fill="white"/>
        </svg>
    </IconButton>
);


export default ZoomInIcon;
